// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".white[data-v-15b60951]{-webkit-filter:invert(1);filter:invert(1);mix-blend-mode:lighten}.code[data-v-15b60951]{color:#fff;background:grey}.pre[data-v-15b60951]{font-family:monospace}.v-tabs-items.full-height-tab .v-window-item[data-v-15b60951]{height:calc(100vh - 160px);width:100%;overflow-y:auto;overflow-x:hidden}", ""]);
// Exports
module.exports = exports;
